import agentsApiConfig from 'api/agents';
import { AGENT_UNREAD_CHAT_MESSAGES } from 'api/agents/endpoints';

export const getUnreadChatMessages = () =>
  agentsApiConfig({
    endpoint: AGENT_UNREAD_CHAT_MESSAGES,
  });
